import { QRCodeCanvas } from 'qrcode.react';
import logoIcon from '../assets/logo-icon.webp';

/**
 * 中心带 logo 的二维码。纠错级 H(30%)，确保 logo 遮挡下仍可扫。
 * 二维码必须深色码点 + 浅色底才可被扫描，故底色固定白、码点固定深 navy，
 * 不随暗黑主题翻转（属"必须浅色"的功能性元素，刻意写死字面色）。
 * value 为空时返回 null，由调用方展示降级文案。
 */
export function QrCode({
  value,
  size = 168,
  className = '',
}: {
  value: string | null | undefined;
  size?: number;
  className?: string;
}) {
  if (!value) return null;
  return (
    <div className={`inline-flex items-center justify-center rounded-md bg-white p-2 ${className}`}>
      <QRCodeCanvas
        value={value}
        size={size}
        level="H"
        marginSize={2}
        bgColor="#ffffff"
        fgColor="#0b1f3a"
        imageSettings={{
          src: logoIcon,
          height: Math.round(size * 0.22),
          width: Math.round(size * 0.22),
          excavate: true,
        }}
      />
    </div>
  );
}
